/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {dataServiceFactory as ɵa} from './src/modules/sila-core.module';